import filterTemplate from '../plpFilter/partials/filters.hbs';
import productListTemplate from './partials/products.hbs';
import resourcesListTemplate from './partials/resources.hbs';
import { showSpinner, hideSpinner } from '/source/_patterns/01-components/spinner/spinner';
import { IS_HIDDEN, IS_ACTIVE } from '/source/js/base/baseClasses';
import * as searchService from '/source/js/services/searchService';
import * as productService from '/source/js/services/productService';
import * as historyUtil from '/source/js/utils/historyUtil';
import * as qsUtil from '/source/js/utils/qsUtil';
import * as cartService from '/source/js/services/cartService';
import { announceCartUpdate } from '/source/js/utils/announceUtil';
import { getGoogleAnalyticsDetails } from '/source/js/services/checkoutService';
import { getFractionCurrencyFormatter, getCurrencyFormatter } from '/source/js/utils/marketUtil';
import * as toastUtil from '/source/js/utils/toastUtil';
import { setDataForAllProducts, addGtmTagToCart, addGlobalQueryIdToRequest } from '/source/js/gtm/IsaGtmCommerce';
import * as crossSellService from '/source/_patterns/01-components/plp/crossSellService';
import * as aeService from '/source/js/services/assistedEnrollmentService';
import * as rcService from '/source/js/services/recommendedCartService';
import { hideCartModalShoppingContext } from '/source/_patterns/01-components/cart-ribbon/cart-ribbon';
import { showDefaultPackContents } from '/source/_patterns/01-components/bp-modals/showPackContents';
import {
    ADD_TO_CART_LOADING_STARTED_MESSAGE,
    ADD_TO_CART_LOADING_COMPLETED_MESSAGE,
    ADD_TO_CART_LOADING_ERROR_MESSAGE,
    CREATE_COPY_LINK_STARTED_MESSAGE,
    CREATE_COPY_LINK_COMPLETED_MESSAGE,
    CREATE_COPY_LINK_ERROR_MESSAGE
} from '../common/common';

const SORT = 'sort';
const OPEN = 'Open';
const QUERY = 'q';
const PAGE = 'page';
const TODAYS_CART_PAGE = $('#todaysCartPageUrl').val();
let googleAnalytics;

let plpData;
let plpLabels;
let $plpSearch;
let $plpFilter;
let $plpList;
let $plpSort;
let $plpCurrentCount;
let $plpResultsTotal;
let $plpFilterDisplaySelected;
let $plpLoadMoreText;
let page = 1;
let resultsCount;
let $plpResources;
let plpResourceData;
let $plpResourcesCurrentCount;
let $plpResourcesResultsTotal;
let $plpProductQtySelector;
let resourcePage = 1;
let resourceTabSelected;
let $plpFilterActionBar;
let isShopPage = false;
let isInIframe = false;
let plpPreselectedFilters;
let plpsharelinklist;
let legacyElement = '#legacy_plp__content';
let marketSettings = window.algoliaData?.currentMarketSettingsContext;
let fractionCurrencyFormatter;
let currencyFormatter;
let $createNewLinkModal;
let $createNewBundleModal;
let selectedProduct;
let bpLabels;
let isAlgoliaSearchEnabled = false;
let newProductsTabSelector;
let newResourcesTabSelector;
let isSearchPageRendering = false;
let $clearAllButton;

async function updateResources(append) {
    try {
        if(append) {
            showSpinner('Loading more resources started');
        } else {
            showSpinner('Loading resources started');
        }

        let searchData = {
            searchTerm: $('.form-input--search').attr('data-value'),
            pageId: $plpSearch.data('page-id'),
            configId: $plpSearch.data('config-id'),
            page: resourcePage,
            pageSize: plpResourceData.PagingSize,
            sort: $plpSort.val(),
            isagenixContext: $plpSearch.data('isagenixcontext')
        };
        let result = await searchService.searchResources(searchData);
        hideSpinner('Loading resources completed');
        if(append) {
            plpResourceData.Resources.push(...result.Resources);
        } else {
            plpResourceData = result;
        }
        if(isSearchPageRendering && $(newResourcesTabSelector).length) {
            $(newResourcesTabSelector).text(result.TotalNumOfResults);
        }
        renderResourcesTab();
    } catch (ex) {
        console.error(ex);
        hideSpinner('Loading resources completed with error');
    }
}

async function updateSearchResults(append, facets) {
    try {
        if(isAlgoliaSearchEnabled && !resourceTabSelected) {
            updateFilterSection();
            return;
        }
        if(append) {
            showSpinner('Loading more products started');
        } else {
            showSpinner('Loading products started');
        }
        if(resourceTabSelected) {
            updateResources(false);
            return;
        }
        var filters = facets;
        if(!filters && facets !== '') {
            var f = $('.plpForm').serialize();
            filters = qsUtil.mergeDuplicateKeys(f, ',');
        }
        let searchData = {
            searchTerm: $('.form-input--search').attr('data-value'),
            pageId: $plpSearch.data('page-id'),
            configId: $plpSearch.data('config-id'),
            page: page,
            pageSize: plpData.PagingSize,
            sort: $plpSort.val(),
            isPaging: append,
            isagenixContext: $plpSearch.data('isagenixcontext')
        };
        if(isShopPage) searchData.searchTerm = '*';
        searchData = { ...searchData, ...qsUtil.parseJson(filters) };
        let result = await searchService.searchProducts(searchData);

        // set bundle and individual link session from context because from api we can get the cached value instead of latest
        result.IsBundleLinkSession = $('#hidden-isBundleLinkSession').val().toLowerCase() === 'true';
        result.IsIndividualLinkSession = $('#hidden-isIndividualLinkSession').val().toLowerCase() === 'true';
        hideSpinner('searching products completed');

        result = configureBadges(result);
        let updatedProducts = result.Products.map(product => ({
            ...product,
            HasCopyLink: plpsharelinklist.some(p => p.ProductSku === product.Sku)
        }));
        result.Products = updatedProducts;
        let productListHtml = productListTemplate(result);
        bpLabels = result.Labels;
        if(append) {
            plpData.Products = plpData.Products.concat(result.Products);
            $plpList.append(productListHtml);
            resultsCount += result.Products.length;
            checkStock(result.Products);
            equalizeProductCards();
        } else {
            plpData = result;
            plpPreselectedFilters = result.PreSelectedFilters;
            renderSearchResults();
        }

        if(result.IsAuthenticatedUser || result.IsRecommendedCartSetup) {
            var quickAddLink = $('.quickAdd');
            var addToCartSection = quickAddLink.find('.price__group');
            addToCartSection.show();
        }
        updateCount(resultsCount, result.TotalNumOfResults);
        if(isSearchPageRendering && $(newProductsTabSelector).length) {
            $(newProductsTabSelector).text(result.TotalNumOfResults);
        }
    } catch (ex) {
        console.error(ex);
        hideSpinner('searching products completed with error');
    }
}

async function updateFilterResults(append, facets) {
    try {
        var filters = facets;
        if(!filters && facets !== '') {
            var f = $('.plpForm').serialize();
            filters = qsUtil.mergeDuplicateKeys(f, ',');
        }
        let data = {
            plpId: $plpFilter.data('categoryId'),
            configId: $plpFilter.data('configId'),
            pageSize: plpData.PagingSize,
            page: page,
            sort: $plpSort.val(),
            isPaging: append,
            isagenixContext: $plpFilter.data('isagenixcontext')
        };
        if(filters) data = { ...data, ...qsUtil.parseJson(filters) };
        if(append) {
            showSpinner('Load more products started');
        } else {
            showSpinner('Loading products started');
        }
        let result = await productService.getProducts(data);
        result.IsBundleLinkSession = $('#hidden-isBundleLinkSession').val().toLowerCase() === 'true';
        result.IsIndividualLinkSession = $('#hidden-isIndividualLinkSession').val().toLowerCase() === 'true';
        result = configureBadges(result);
        let updatedProducts = result.Products.map(product => ({
            ...product,
            HasCopyLink: plpsharelinklist.some(p => p.ProductSku === product.Sku)
        }));
        result.Products = updatedProducts;
        let productListHtml = productListTemplate(result);
        bpLabels = result.Labels;
        if(append) {
            plpData.Products = plpData.Products.concat(result.Products);
            $plpList.append(productListHtml);
            resultsCount += result.Products.length;
            checkStock(result.Products);
            equalizeProductCards();
        } else {
            plpData = result;
            plpPreselectedFilters = result.PreSelectedFilters;
            renderFilterResults();
        }
        $plpProductQtySelector = $('.plp__mobile-qty-selector');
        $plpProductQtySelector.on('click', '.increase-items', increaseItemsFilter);
        $plpProductQtySelector.on('click', '.decrease-items', decreaseItemsFilter);
        if(result.IsAuthenticatedUser || result.IsRecommendedCartSetup) {
            var quickAddLink = $('.quickAdd');
            var addToCartSection = quickAddLink.find('.price__group');
            addToCartSection.show();
        }
        updateCount(resultsCount, result.TotalNumOfResults);
        hideSpinner('loading products completed');
    } catch (ex) {
        console.error(ex);
        hideSpinner('loading products completed with error');
    }
}

function equalizeProductCards() {
    if($.fn.matchHeight) {
        $('.plp__list .plp__product-info').matchHeight({ byRow: true });
        var $images = $('.plp__list .plp__product-image');
        $images.each(function() {
            if(!this.complete) {
                $(this).one('load error', function() {
                    $.fn.matchHeight._update();
                });
            }
        });
    }
}

function configureBadges(result) {
    const newProductList = [];
    result.Products.forEach(product => {
        let updatedProduct = product;
        if(product.Facets && product.Facets.length > 0) {
            const badgeInfoList = product.Facets.filter(f => f.BadgeInfo !== null).map(f => f.BadgeInfo);
            const lowestBadge = getLowestRankBadge(badgeInfoList);
            if(lowestBadge != null) {
                updatedProduct = { ...updatedProduct, badge: lowestBadge };
            }
        }
        newProductList.push(updatedProduct);
    });
    return { ...result, Products: newProductList };
}

function getLowestRankBadge(badgeInfoList) {
    if(badgeInfoList.length === 0) return null;
    return badgeInfoList.reduce((lowest, badge) => {
        const rank = parseInt(badge.Rank, 10);
        if(isNaN(rank)) return lowest;
        return (lowest === null || rank < parseInt(lowest.Rank, 10)) ? badge : lowest;
    }, null);
}

function clearSelected() {
    let $this = $(this);
    let inputName = $this.data('selected-name');
    let $input = $(`#${inputName}`);
    if($input.is('input[type="number"]') || $input.is('input[type="text"]')) {
        $input.val('');
    } else {
        $input.prop('checked', false);
    }
    $this.parent('.plpFilter__selected-option').remove();
    filterCount();
    page = 1;
    var filters = updateHistory();
    if($plpSearch.length) updateSearchResults(false, filters);
    else updateFilterResults(false, filters);
}

function toggleFacets(e) {
    let $this = $(this);
    let $plpFilterOptions = $this.parent();
    let showQuantity = $plpFilterOptions.data('show-quantity');
    $plpFilterOptions.find(`>li:nth-child(n+${showQuantity + 1})`).toggle();
    $this.toggleClass('flip');
    $this.attr('aria-expanded', $this.hasClass('flip') ? 'false' : 'true');
    $this.children('.show-text--more, .show-text--less').toggleClass('d-none');
    if(e.detail !== 0) return;
    // find parent quantity and refocus
    const $parent = $this.closest('ul.plpFilter__options');
    if(!$parent.length) return;
    const maxQuantity = Number($parent.data('show-quantity')) || 0;
    const $items = $parent.find('li.plpFilter__form');
    if(!maxQuantity || !$items.length) return;
    const nextIndex = (maxQuantity) % $items.length;
    $items.eq(nextIndex).find('input:first').focus();
}

function increaseItems($currentTarget) {
    let input = $currentTarget.siblings('.quantity-input');
    let inputValue = input.val();
    let max = parseInt(input.attr('max'));
    let min = parseInt(input.attr('min'));
    let minusBtn = $currentTarget.siblings('.decrease-items');
    let value;
    if(inputValue !== '') {
        value = parseInt(inputValue);
    } else {
        return;
    }
    $currentTarget.prop('disabled', false);
    if(value < max) value = value + 1;
    if(value === max) $currentTarget.prop('disabled', true);
    if(value > min) minusBtn.prop('disabled', false);
    input.val(value);
}

function decreaseItems($currentTarget) {
    let input = $currentTarget.siblings('.quantity-input');
    let inputValue = input.val();
    let min = parseInt(input.attr('min'));
    let max = parseInt(input.attr('max'));
    let addBtn = $currentTarget.siblings('.increase-items');
    let value;
    if(inputValue !== '') {
        value = parseInt(inputValue);
    } else {
        return;
    }
    $currentTarget.prop('disabled', false);
    if(value > min) value = value - 1;
    if(value === min) $currentTarget.prop('disabled', true);
    if(value < max) addBtn.prop('disabled', false);
    input.val(value);
}

function increaseItemsSearch(element) {
    let $currentTarget = element;
    increaseItems($currentTarget);
}

function decreaseItemsSearch(element) {
    let $currentTarget = element;
    decreaseItems($currentTarget);
}

function increaseItemsFilter(event) {
    let $currentTarget = $(event.currentTarget);
    increaseItems($currentTarget);
}

function decreaseItemsFilter(event) {
    let $currentTarget = $(event.currentTarget);
    decreaseItems($currentTarget);
}

function renderSearchResults() {
    if(resourceTabSelected) return;
    if(!plpData) return;
    resultsCount = plpData.NumOfResultsReturned;
    page = plpData.Page;
    if(plpData.TotalNumOfResults > 0) {
        $('.plp__load-more,.plp__total-message').removeClass(IS_HIDDEN);
    }
    updateCount(resultsCount, plpData.TotalNumOfResults);
    let productListHtml = productListTemplate(plpData);
    $plpList.html(productListHtml);
    checkStock(plpData.Products);
    updateFilterSection();
    equalizeProductCards();
}

function renderFilterResults() {
    if(!plpData) return;
    let $plpFilterContent = $plpFilter.find('.plpFilter__content');
    resultsCount = plpData.NumOfResultsReturned;
    page = plpData.Page;
    if(plpData.TotalNumOfResults > 0) {
        $('.plp__load-more,.plp__total-message').removeClass(IS_HIDDEN);
    }
    updateCount(resultsCount, plpData.TotalNumOfResults);
    let productListHtml = productListTemplate(plpData);
    $plpList.html(productListHtml);
    var filters = updateSelectedFilters(plpData.Filters);
    filters = filters.map((filter, i) => ({ ...filter, Values: filter.Values.map((subfilter, i) => ({ ShowFilter: !subfilter.HideFilter, ...subfilter })) }));
    let filteredData = { labels: plpLabels, plpFilters: filters, isshoppage: isShopPage, isiniframe: isInIframe };
    filteredData.isNewSearchExperience = false;
    if($plpSearch.length > 0 && isSearchPageRendering && filteredData && filteredData !== null && filteredData !== 'undefined') {
        filteredData.isNewSearchExperience = true;
    }
    let filtersHtml = filterTemplate(filteredData);
    $plpFilterContent.html(filtersHtml);
    let $plpFilterOptions = $('.plpFilter__options');
    $plpFilterOptions.each(function () {
        let $this = $(this);
        let showQuantity = $this.data('show-quantity');
        if(showQuantity && $this.children('li').length > showQuantity) {
            $this.children(`li:nth-child(n+${showQuantity + 1})`).hide();
            $this.find('.show-text--more').text(plpLabels.ViewMoreLabel);
            $this.find('.show-text--less').text(plpLabels.ViewLessLabel);
            $this.find('.show-more').removeClass('d-none').attr('aria-hidden', 'false');
        }
    });
    preselectFilters();
    filterCount();
    checkStock(plpData.Products);
    equalizeProductCards();
}

function updateFilterSection() {
    let labels = plpLabels;
    let $plpFilterContent = $plpFilter.find('.plpFilter__content');
    let plpFilters = plpData.Filters;
    let filters = updateSelectedFilters(plpFilters);
    filters = filters.map((filter, i) => ({ ...filter, Values: filter.Values.map((subfilter, i) => ({ ShowFilter: !subfilter.HideFilter, ...subfilter })) }));
    let filteredData = { labels: labels, plpFilters: filters, isshoppage: isShopPage, isiniframe: isInIframe };
    filteredData.isNewSearchExperience = false;
    if($plpSearch.length > 0 && isSearchPageRendering && filteredData && filteredData !== null && filteredData !== 'undefined') {
        filteredData.isNewSearchExperience = true;
    }
    let filtersHtml = filterTemplate(filteredData);
    if(!resourceTabSelected) {
        $plpFilterContent.html(filtersHtml);
        setActiveTab();
    }

    updateSearchResultsLabels();
    let $plpFilterOptions = $('.plpFilter__options');
    $plpFilterOptions.each(function () {
        let $this = $(this);
        let showQuantity = $this.data('show-quantity');
        if(showQuantity && $this.children('li').length > showQuantity) {
            $this.children(`li:nth-child(n+${showQuantity + 1})`).hide();
            $this.find('.show-text--more').text(plpLabels.ViewMoreLabel);
            $this.find('.show-text--less').text(plpLabels.ViewLessLabel);
            $this.find('.show-more').removeClass('d-none').attr('aria-hidden', 'false');
        }
    });
    preselectFilters();
    filterCount();
}

function setActiveTab() {
    let productsRadio = $('#products-tab');
    let resourcesRadio = $('#resources-tab');
    toggleFilters(document.createEvent('Event'));
    if(resourceTabSelected) {
        $(productsRadio).removeClass('active');
        $(productsRadio).attr('aria-selected', 'false');
        $('.plp__tab .products').removeClass('active');
        $('.plp__tab .products-list').removeClass('active show');
        $(resourcesRadio).addClass('active');
        $(resourcesRadio).attr('aria-selected', 'true');
        $('.plp__tab .resources').addClass('active');
        $('.plp__tab .resources-list').addClass('active show');
    } else {
        $(productsRadio).addClass('active');
        $(productsRadio).attr('aria-selected', 'true');
        $('.plp__tab .products').addClass('active');
        $('.plp__tab .products-list').addClass('active show');
        $(resourcesRadio).removeClass('active');
        $(resourcesRadio).attr('aria-selected', 'false');
        $('.plp__tab .resources').removeClass('active');
        $('.plp__tab .resources-list').removeClass('active show');
    }
}

function productsTabClickHandler(e) {
    e.preventDefault();
    resourceTabSelected = false;
    setActiveTab();
    updateSearchResultsLabels();
    $('.plpFilter__display-selected').css('display', 'block');
    $('.plp__search-form .plp__results-header').show();
    if(isAlgoliaSearchEnabled) {
        $('.plp__search-form .form-group').hide();
    }
    $('.plp__sorting').show();
    $('#products-tab').addClass('active');
    $('#resources-tab').removeClass('active');
    $('.plp__empty-state').show();
}

function resourcesTabClickHandler(e) {
    e.preventDefault();
    resourceTabSelected = true;
    setActiveTab();
    renderResourcesTab();
    updateSearchResultsLabels();
    $('.plpFilter__display-selected').hide();
    $('.plp__search-form .plp__results-header').hide();
    $('.plp__search-form .form-group').show();
    $('.plp__sorting').hide();
    $('#resources-tab').addClass('active');
    $('#products-tab').removeClass('active');
    $('.plp__empty-state').hide();
}

function preselectFilters() {
    var qs = new URLSearchParams(window.location.search);
    if(plpPreselectedFilters) {
        $.each(plpPreselectedFilters, function (key, value) {
            var qsvalue = qs.get(value.Key);
            if(!qsvalue || (qsvalue && !qsvalue.includes(value.Value))) {
                qs.append(value.Key, value.Value);
            }
        });
    }
    $plpFilterDisplaySelected.find('>span').remove();
    qs.forEach((v, k) => {
        if(k === 'isagenixContext') return;
        var $filter = $(`input[name='${k}']`);
        if($filter.is(':checkbox') || $filter.is(':radio')) {
            if(v.indexOf(',') > -1) {
                let values = v.split(',');
                values.forEach(i => {
                    let $individual = $filter.filter(`[value='${i}']`);
                    showFilter($individual);
                    $individual.prop('checked', true);
                });
            } else {
                let $individual = $filter.filter(`[value='${v}']`);
                showFilter($individual);
                $individual.prop('checked', true);
            }
        } else {
            $filter.val(v);
            if(v && ($filter.is('input[type="number"]') || $filter.is('input[type="text"]'))) {
                showFilter($filter, v);
            }
        }
    });
}

function filterCount() {
    let $plpFilterTotal = $('.plpFilter__total');
    let count = $('.plpFilter__display-selected > span').length / 2;
    let $mobileContainer = $('.plpFilter__mobile-container');
    let $checkMarkContainer = $mobileContainer.find('.check-mark-container');
    let $checkMark = $mobileContainer.find('.check-mark');
    $checkMarkContainer.show();
    $plpFilterTotal.text('(' + count + ')');
    if(count > 0) {
        $checkMark.html(count);
        $mobileContainer.addClass('plpFilter__mobile-container--selected');
    } else {
        $plpFilterTotal.text('');
        $checkMark.html('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 6.5C5 6.225 5.225 6 5.5 6H18.5C18.775 6 19 6.225 19 6.5C19 6.775 18.775 7 18.5 7H5.5C5.225 7 5 6.775 5 6.5ZM7 11.5C7 11.225 7.225 11 7.5 11H16.5C16.775 11 17 11.225 17 11.5C17 11.775 16.775 12 16.5 12H7.5C7.225 12 7 11.775 7 11.5ZM14 16.5C14 16.775 13.775 17 13.5 17H10.5C10.225 17 10 16.775 10 16.5C10 16.225 10.225 16 10.5 16H13.5C13.775 16 14 16.225 14 16.5Z" fill="#727677"/></svg>');
        $mobileContainer.removeClass('plpFilter__mobile-container--selected');
        $plpFilterDisplaySelected.hide();
    }
}

function clearAll() {
    $('.form-input--checkbox').prop('checked', false);
    $('.plpFilter__display-selected').hide();
    $('.plpFilter__selected-option').remove();
    $('.plpFilter__total').text('');
    $('.plpFilter__form').find('input[type=text],input[type=number]').val('');
    updateFilter();
}

function initCurrencyFormatter() {
    fractionCurrencyFormatter = getFractionCurrencyFormatter(marketSettings);
    currencyFormatter = getCurrencyFormatter(marketSettings);
}

async function updateSort() {
    page = 1;
    historyUtil.pushQueryString(SORT, $plpSort.val());
    $('#sort').val($plpSort.val());
    var selectedText = $plpSort.find('option:selected').text().trim();
    $('#plpSortAnnouncement').text('Products sorted by ' + selectedText);
    if($plpSearch.length) await updateSearchResults(false);
    else await updateFilterResults(false);
}

function updateSelectedFilters(filters) {
    if(!filters) return filters;
    var qs = new URLSearchParams(window.location.search);
    qs.forEach((v, k) => {
        var filter = filters.find(i => i.FilterId === k);
        if(filter) filter.DisplayState = OPEN;
    });
    return filters;
}

function updateSearchResultsLabels() {
    $clearAllButton = $('.plpFilter__clear');
    $clearAllButton.text(plpLabels.ClearAllLabel);
    if(resourceTabSelected) {
        $clearAllButton.hide();
        $('.plpFilter__clear-all-button').addClass('plpFilter__clear-all-button--hide');
        if(plpResourceData.TotalNumOfResults > 0) {
            $plpLoadMoreText.text(`${plpLabels.ViewingLabel} ${plpResourceData.NumOfResultsReturned} ${plpLabels.OfLabel} ${plpResourceData.TotalNumOfResults} ${plpLabels.ResourcesLabel}`);
            $plpLoadMoreText.parent().removeClass(IS_HIDDEN);
            $plpResourcesResultsTotal.text(`${plpResourceData.TotalNumOfResults} ${plpLabels.ResultsLabel}`);
            $('.form-label--search').text(`${plpLabels.ShowingLabel} ${plpResourceData.TotalNumOfResults} ${plpLabels.ResultsForLabel}`);
            $('.plp__no-results').addClass(IS_HIDDEN);
        } else {
            $('.form-label--search').text(`${plpLabels.ShowingLabel} ${plpResourceData.TotalNumOfResults} ${plpLabels.ResultsForLabel}`);
            $('.plp__load-more,.plp__total-message').addClass(IS_HIDDEN);
            $('.plp__no-results').removeClass(IS_HIDDEN);
            $('.plp__search-form').addClass('no-results');
        }
        $('.form-label--search').css({ 'margin': '0', 'font-size': '14px' });
        $('.plp__search-query').css({ 'padding-left': '0', 'font-size': '14px' });
    } else {
        $('.plpFilter__clear-all-button').removeClass('plpFilter__clear-all-button--hide');
        if(!isAlgoliaSearchEnabled) {
            $('.form-label--search').text(`${plpLabels.ShowingLabel} ${plpData.TotalNumOfResults} ${plpLabels.ResultsForLabel}`);
        }
        if(plpData.TotalNumOfResults > 0) {
            $plpLoadMoreText.text(`${plpLabels.ViewingLabel} ${plpData.NumOfResultsReturned} ${plpLabels.OfLabel} ${plpData.TotalNumOfResults} ${plpLabels.ProductsLabel}`);
            $plpLoadMoreText.parent().removeClass(IS_HIDDEN);
            if(isShopPage) $plpResultsTotal.text(`${plpData.TotalNumOfResults}`);
            else $plpResultsTotal.text(`${plpData.TotalNumOfResults} ${plpLabels.ResultsLabel}`);
            $('.plp__no-results').addClass(IS_HIDDEN);
        } else {
            $('.plp__load-more,.plp__total-message').addClass(IS_HIDDEN);
            $('.plp__no-results').removeClass(IS_HIDDEN);
            $('.plp__search-form').addClass('no-results');
        }
    }
}

function updateCount(current, total) {
    if(resourceTabSelected) {
        $plpResourcesCurrentCount.text(current);
        $plpResourcesResultsTotal.text(total);
        $plpLoadMoreText.text(`${plpLabels.ViewingLabel} ${current} ${plpLabels.OfLabel} ${total} ${plpLabels.ResourcesLabel}`);
        plpResourceData.NumOfResultsReturned = current;
        plpResourceData.TotalNumOfResults = total;
        if(current >= total) $('.plp__tab-pane.tab-pane#resources #btn_plp_LoadMore').addClass(IS_HIDDEN);
        else $('.plp__tab-pane.tab-pane#resources #btn_plp_LoadMore').removeClass(IS_HIDDEN);
    } else {
        $plpLoadMoreText.html(`${plpLabels.ViewingLabel}  <span class="plp__current-count"></span> ${plpLabels.OfLabel} <span class="plp__results-total"></span> ${plpLabels.ProductsLabel}`);
        $plpCurrentCount = $('.plp__current-count');
        $plpResultsTotal = $('.plp__results-total');
        plpData.NumOfResultsReturned = current;
        plpData.TotalNumOfResults = total;
        $plpCurrentCount.text(current);
        $plpResultsTotal.text(total);
        if(current >= total) $('.plp__tab-pane.tab-pane#products #btn_plp_LoadMore').addClass(IS_HIDDEN);
        else $('.plp__tab-pane.tab-pane#products #btn_plp_LoadMore').removeClass(IS_HIDDEN);
    }
}

function updateHistory() {
    var filters = $('.plpForm').serialize();
    filters = qsUtil.mergeDuplicateKeys(filters, ',');
    filters = qsUtil.addOrUpdateQuerystring(filters, SORT, $plpSort.val());
    if(!isShopPage && $('.form-input--search').length) {
        filters = qsUtil.addOrUpdateQuerystring(filters, QUERY, $('.form-input--search').attr('data-value'));
    }
    filters = qsUtil.addQuerystring(filters, PAGE, page);
    historyUtil.pushQueryStrings(filters);
    return filters;
}

function updateFilter(e) {
    if(resourceTabSelected) {
        resourcePage = 1;
        updateResources(false);
    } else {
        page = 1;
        var filters = updateHistory();
        if($plpSearch.length) updateSearchResults(false, filters);
        else updateFilterResults(false, filters);
    }
}

function updateQueryFilter(e) {
    let $this = $(this);
    $('#q').val($this.val());
}

function enterQueryFilter(e) {
    if(e.keyCode === 13) {
        if($plpSearch.length) updateFilter();
        else filterSearchResult(e);
    }
}

function filterSearchResult(e) {
    var $searchInputHeader = $('.navbar__search');
    $searchInputHeader.val($('.form-input--search').val());
    if($searchInputHeader.val()) $('#searchForm').submit();
}

function showFilter($this, filterVal) {
    let id = $this.attr('id');
    let display = $this.data('filter-name');
    $plpFilterDisplaySelected = $('.plpFilter__display-selected');
    if(display) {
        $plpFilterDisplaySelected.show();
        if($this.is('input[type="number"]') || $this.is('input[type="text"]')) {
            display = display.charAt(0).toUpperCase() + display.slice(1);
            var symbol = $this.attr('name').indexOf('-min') > -1 ? '>' : '<';
            display = `${display} ${symbol} ${filterVal}`;
        }
        let selectedDiv = $plpSearch.length
            ? `<span data-filter-name="${id}" class="plpFilter__selected-option"><span>${display}</span><button type="button" aria-label="remove filter ${display}" class="plpFilter__clear-selected" data-selected-name=${id}><i class="fal fa-xmark icon-medium icon-close"></i></button></span>`
            : `<span data-filter-name="${id}" class="plpFilter__selected-option badge badge-turquoise-100 color-turquoise-700"><span>${display}</span><button aria-label="remove filter ${display}" class="plpFilter__clear-selected" data-selected-name=${id}><i class="fal fa-xmark icon-medium icon-close"></i></button></span>`;
        $plpFilterDisplaySelected.append(selectedDiv);
    }
}

async function loadMore() {
    if(resourceTabSelected) {
        resourcePage++;
        await updateResources(true);
        renderResourcesTab();
    } else {
        page++;
        historyUtil.pushQueryString(PAGE, page);
        if($plpSearch.length) await updateSearchResults(true);
        else await updateFilterResults(true);
    }
}

function toggleFilters(e) {
    e.preventDefault();
    $('.plpFilter').css('display', 'none');
    $('.plp__sorting').removeClass(IS_HIDDEN);
    if(resourceTabSelected) {
        $('.plp__sorting').css('width', '50%');
        $('.plp__sorting .plp__select').addClass(IS_HIDDEN);
    } else {
        $('.plp__sorting').css('width', '');
        $('.plp__sorting .plp__select').removeClass(IS_HIDDEN);
    }
}

function clearSearchQuery() {
    $('.form-input--search').val('').focus();
}

function toggleMobile(e) {
    e.preventDefault();
    let $plpFilter = $('.plpFilter');
    $plpFilter.toggle();
}

function submitSearchForm(e) {
    e.preventDefault();
    updateFilter(e);
}

async function loadInitialResults() {
    $plpSearch = $('.plp--search');
    if($plpSearch.length < 1 && !$plpFilter.length) return;
    if(!isAlgoliaSearchEnabled) {
        historyUtil.pushQueryString(PAGE, page);
        if(plpPreselectedFilters) {
            $.each(plpPreselectedFilters, function (key, value) {
                historyUtil.pushQueryString(value.Key, value.Value);
            });
        }
    }
    if($plpSearch.length) await updateSearchResults(false, window.location.search.substring(1));
    else await updateFilterResults(false, window.location.search.substring(1));
}

function initEventHandlers() {
    $plpSearch = $('.plp--search');
    $plpFilter = $('.plp');
    const isSearchContext = $plpSearch.length > 0;
    const $context = isSearchContext ? $plpSearch : $plpFilter;
    if(!$context.length) return;
    initializeData(isSearchContext);
    if(!plpData) return;
    $('#algResultsLabel').text(`${plpLabels.ResultsLabel}`).css({ 'font-size': '20px', 'font-weight': 'bold', 'text-transform': 'uppercase' });
    setupGlobalEventListeners();
    setupContextSpecificEventListeners(isSearchContext);
    setupSharedEventListeners();
    updateResultsLabels(isSearchContext);
    setPage(window.location.search);
    $('.plp__content').on('blur', '.price__quantity-sign--amount', function () {
        const $input = $(this);
        let val = parseFloat($input.val());
        const max = parseFloat($input.attr('max'));
        const $inc = $input.siblings('.increase-items');
        const $dec = $input.siblings('.decrease-items');
        if(isNaN(val)) {
            val = 1;
        }
        if(val >= max) {
            $input.val(max);
            $inc.prop('disabled', true);
            $dec.prop('disabled', false);
        } else if(val <= 1) {
            $input.val(1);
            $dec.prop('disabled', true);
            $inc.prop('disabled', false);
        } else {
            $inc.prop('disabled', false);
            $dec.prop('disabled', false);
        }
    });
}

function initializeData(isSearchContext) {
    window.onpopstate = (e) => {
        const currentSearch = e.currentTarget.location.search;
        if(currentSearch !== window.lastSearch) {
            window.lastSearch = currentSearch;
            navigateHistory(currentSearch);
        }
    };
    plpData = (isSearchContext ? $plpSearch : $plpFilter).data('plp-details');
    plpLabels = (isSearchContext ? $plpSearch : $plpFilter).data('labels');
    plpPreselectedFilters = (isSearchContext ? $plpSearch : $plpFilter).data('plp-preselectedfilters');
    plpsharelinklist = window.shareLinkList || [];
    $plpFilter = isSearchContext ? $('.plp--search .plpFilter') : $plpFilter;
    $plpFilterActionBar = $('.plpFilter__action-bar .button');

    if(isSearchContext) {
        plpResourceData = $plpSearch.data('plp-resources-details');
        isShopPage = !!$plpSearch.data('isshoppage');
        isInIframe = !!$plpSearch.data('isiniframe');
    }
}

function setupGlobalEventListeners() {
    const $body = $('body');
    $(document).on('click', '.view-pack-contents', showDefaultPackContents);
    $(document).on('click', '.show-more', toggleFacets);
    $body.on('click', '.crossSellAddProduct', crossSellService.crossSellAddProduct);
    $body.on('click', '.crossSellAddPack', crossSellService.crossSellAddPack);
    $body.on('click', '.quickCreateALink', createALink);
    $body.on('click', '.quickCopyLink', copyShareLink);
    $body.on('click', '.resume-enrollment-button-primary', redirectToCartPage);
    $body.on('click', '.resume-enrollment-button-secondary', deleteAECarts);
    $body.on('click', '.continue-create-recommendedCart-btn', updateRecommendedCartFlag);
    $body.on('click', '.continue-create-bundle-btn, .continue-create-link-btn', updateBPFlowFlags);
    if(isSearchPageRendering) {
        $('#resources-tab').on('click', resourcesTabClickHandler);
        $('#products-tab').on('click', productsTabClickHandler);
    }
}

function setupContextSpecificEventListeners(isSearchContext) {
    const $plpSearchButton = $('.plp__search-btn--search');
    const $plpSearchClearButton = $('.plp__search-btn--clear');
    const $inputSearch = $('.form-input--search');

    if(isSearchContext) {
        $('.plp__search-form').on('submit', submitSearchForm);
        $('.plpFilter').on('show.bs.tab', '.plp__nav a[data-toggle="tab"]', (e) => {
            const target = $(e.target).attr('href');
            $(target).addClass('active show').siblings('.tab-pane.active').removeClass('active show');
            toggleTabs();
            updateSearchResultsLabels();
        });
        $plpSearchButton.on('click', updateFilter);
        $plpSearchClearButton.on('click', clearSearchQuery);
        $inputSearch.on('blur', updateQueryFilter);
        $inputSearch.on('keyup', enterQueryFilter);
        $plpSearch.on('click', '.quickAddToCart:not(.ais-search-cta-button)', addToCart);
    } else {
        $plpSearchClearButton.on('click', clearSearchQuery);
        $plpSearchButton.on('click', filterSearchResult);
        $inputSearch.on('keyup', enterQueryFilter);
        $plpFilter.on('click', '.quickAddToCart:not(.ais-search-cta-button)', addToCart);
    }

    initializeModals();
}

function handleFilterKeyNavigation(e) {
    try {
        let $target = $(this);
        let $form = $target.is('input[type="checkbox"]') ? $target.closest('.plpFilter__form') : $(this);
        if(!$form.length) return;
        if(e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            if($form.hasClass('ais-RefinementList-item')) {
                $form.trigger('click');
            } else {
                $form.find('.form-input--checkbox').trigger('click');
            }
            return;
        }

        if(e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            let $ul = $form.closest('ul.plpFilter__options');
            if(!$ul.length) return;

            let $items = $ul.find('.plpFilter__form');
            if(!$items.length) return;

            let index = $items.index($form);

            if(e.key === 'ArrowDown') {
                let nextIndex = (index + 1) % $items.length;
                $items.eq(nextIndex).find('input').focus();
            }

            if(e.key === 'ArrowUp') {
                let prevIndex = (index - 1 + $items.length) % $items.length;
                $items.eq(prevIndex).find('input').focus();
            }
        }
    } catch (err) {
        console.error('Error in handleFilterKeyNavigation:', err);
    }
}

function setupSharedEventListeners() {
    const $plpFilterMobileToggle = $('.plpFilter__mobile-toggle');
    const $plpFilterClear = $('.plpFilter__clear');
    $plpLoadMoreText = $('.plp__load-more-text');
    $plpSort = $('#plpSort');
    $plpList = $('.plp__list');
    $plpCurrentCount = $('.plp__current-count');
    $plpResultsTotal = $('.plp__results-total');
    $plpResourcesCurrentCount = $('.resources-list .plp__current-count');
    $plpResourcesResultsTotal = $('.resources-list .plp__results-total');
    $plpResources = $('.plp__resources');
    $plpFilterDisplaySelected = $('.plpFilter__display-selected');
    if($plpSearch.length) {
        $plpFilter.on('change', updateFilter);
    } else {
        $plpFilter.on('change', '.plpFilter', updateFilter);
    }

    $('.plpFilter').on('keydown', '.plpFilter__form', handleFilterKeyNavigation);
    $plpFilterDisplaySelected.on('click', '.plpFilter__clear-selected', clearSelected);
    $plpFilterMobileToggle.on('click', toggleMobile);
    $plpFilterClear.on('click', clearAll);
    $('body').on('click', '.plp__tab-pane.tab-pane .plp__loadmore', loadMore);
    $plpSort.on('change', updateSort);
    $plpFilterActionBar.on('click', toggleFilters);

    if($plpFilterDisplaySelected.length === 0) $(document).on('click', '.plpFilter__clear-selected', clearSelected);
    if($plpFilterClear.length === 0) $(document).on('click', '.plpFilter__clear', clearAll);
    if($plpFilterActionBar.length === 0) $(document).on('click', '.plpFilter__action-bar .button', toggleFilters);
}

function initializeModals() {
    const $createNewRCModal = $('#createNewRecoModal');
    $createNewLinkModal = $('#createNewLinkModal');
    $createNewBundleModal = $('#createNewBundleModal');

    $('#resumeEnrollment').modal('show');
    $createNewRCModal.modal('show');
    $createNewRCModal.on('hidden.bs.modal', updateRecommendedCartFlag);
    $createNewLinkModal.modal('show');
    $createNewBundleModal.modal('show');
    $createNewLinkModal.on('hidden.bs.modal', updateBPFlowFlags);
    $createNewBundleModal.on('hidden.bs.modal', updateBPFlowFlags);
}

function updateResultsLabels(isSearchContext) {
    if(isSearchContext) {
        updateSearchResultsLabels();
    } else {
        const $plpLoadMoreText = $('.plp__load-more-text');
        if(plpData.TotalNumOfResults > 0) {
            $plpLoadMoreText.html(`${plpLabels.ViewingLabel} <span class="plp__current-count">${plpData.NumOfResultsReturned}</span> ${plpLabels.OfLabel} <span class="plp__results-total">${plpData.TotalNumOfResults}</span> ${plpLabels.ProductsLabel}`);
            $plpResultsTotal.text(plpData.TotalNumOfResults + ' results');
        } else {
            $('.plp__load-more,.plp__total-message').addClass(IS_HIDDEN);
            $('.plp__no-results').removeClass(IS_HIDDEN);
            $('.plp__search-form').addClass('no-results');
            $('.form-label--search').toggleClass(IS_HIDDEN);
        }
    }
}

async function updateBPFlowFlags() {
    let buttonElement = $(this);
    if($(this).hasClass('isa-modal')) buttonElement = $(this).find('.create-new-modal button');
    const isLink = buttonElement.attr('data-is-link') === 'true';
    if(isLink) $createNewLinkModal.modal('hide');
    else $createNewBundleModal.modal('hide');
    try {
        await rcService.updateBPFlags(isLink);
    } catch (ex) {
        console.error(ex);
        showErrorMessage('Unexpected error');
    }
}

async function updateRecommendedCartFlag() {
    $('#createNewRecoModal').modal('hide');
    try {
        await rcService.updateRecommendedCartFlag();
    } catch (ex) {
        console.error(ex);
        showErrorMessage('Unexpected error');
    }
}

async function redirectToCartPage() {
    await saveAssistedEnrollmentSession();
    window.location.href = TODAYS_CART_PAGE;
}

async function saveAssistedEnrollmentSession() {
    $('#resumeEnrollment').modal('toggle');
    try {
        await aeService.saveAsisistedEnrollmentSession();
    } catch (ex) {
        console.error(ex);
        showErrorMessage('Unexpected error');
    }
}

async function deleteAECarts() {
    showSpinner('deleting assisted enrollment carts started');
    try {
        const result = await aeService.deleteAECarts();
        $('.header__cart-items').text('').addClass('d-none');
        announceCartUpdate(0);
        $('#resumeEnrollment').modal('toggle');
        if(result !== '') window.location.href = result;
    } catch (ex) {
        console.error(ex);
        showErrorMessage('Unexpected error');
    }
    hideSpinner('deleting assisted enrollment carts completed');
}

async function addToCart(event) {
    event.preventDefault();
    let $currentTarget = $(event.currentTarget);
    let $mobileParent = $currentTarget.closest('.plp__product-details');
    let $mobileQtySelectedValue = $mobileParent.find('.plp__mobile-qty-selector').find('.quantity-input').val();
    const qty = $mobileQtySelectedValue;
    if(!plpData.IsAuthenticatedUser) return;
    if($currentTarget.attr('disabled')) return;
    let productId = $currentTarget.parent('.price__group').data('id');
    selectedProduct = plpData.Products.filter(item => item.Id === productId)[0];
    if(!selectedProduct) {
        console.error('addToCart - cannot find product');
        return;
    }
    if(selectedProduct.IsBundle) {
        let href = qsUtil.addUrlQuerystring(selectedProduct.Url, 'open', '1');
        window.location.href = qsUtil.addUrlQuerystring(href, 'isquickadd', qty);
        return;
    }
    var uri = selectedProduct.Url;
    if(uri.indexOf('?') > 0) {
        var cleanUri = uri.substring(0, uri.indexOf('?'));
        selectedProduct.Url = cleanUri;
    }
    initCurrencyFormatter();
    if(selectedProduct.IsKit) await addKitToCart(selectedProduct, qty);
    else await addProductToCart(selectedProduct, qty);
    addGtmTagToAddToCart(selectedProduct.Sku);
}

async function addKitToCart(selectedProduct, quantity) {
    showSpinner(ADD_TO_CART_LOADING_STARTED_MESSAGE);
    try {
        const result = await cartService.addKitToCart({
            FamilyId: selectedProduct.FamilyId,
            ProductId: `Isagenix_Master|${selectedProduct.Id}|`,
            BundleConfigurationId: selectedProduct.BundleConfigurationId,
            Sku: selectedProduct.Sku,
            Quantity: quantity,
            ProductPageRelativeUrl: selectedProduct.Url,
            PriceType: selectedProduct.DefaultPriceType,
            ProductFamilyDisplayName: selectedProduct.ProductFamilyDisplayName,
            TryOnce: false,
            IsQuickAdd: true
        });
        if(result.IsSuccessful) {
            hideSpinner(ADD_TO_CART_LOADING_COMPLETED_MESSAGE);
            googleAnalytics = result.GoogleAnalyticsProperties;
            cartService.updateQSForMergeCart();
            hideCartModalShoppingContext(selectedProduct.DefaultPriceType);
            showCartItemAdded(result, quantity);
        } else {
            hideSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
            console.error(result);
            addToCartFailed(result);
        }
    } catch (ex) {
        console.error(ex);
        hideSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
    }
}

async function addProductToCart(selectedProduct, quantity) {
    showSpinner(ADD_TO_CART_LOADING_STARTED_MESSAGE);
    try {
        const result = await cartService.addToCart({
            FamilyId: selectedProduct.FamilyId,
            FamilyName: selectedProduct.Name,
            ProductId: `Isagenix_Master|${selectedProduct.Id}|`,
            Quantity: quantity,
            ProductPageRelativeUrl: selectedProduct.Url,
            PriceType: selectedProduct.DefaultPriceType,
            TryOnce: false,
            IsQuickAdd: true
        });
        if(result.IsSuccessful) {
            hideSpinner(ADD_TO_CART_LOADING_COMPLETED_MESSAGE);
            googleAnalytics = result.GoogleAnalyticsProperties;
            cartService.updateQSForMergeCart();
            hideCartModalShoppingContext(selectedProduct.DefaultPriceType);
            showCartItemAdded(result, quantity);
        } else {
            hideSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
            console.error(result);
            addToCartFailed(result);
        }
    } catch (ex) {
        console.error(ex);
        hideSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
    }
}

function addToCartFailed(result) {
    let msg = '';
    if(result.Messages) {
        let msgo = result.Messages.find(msg => msg.DisplayMessage === true);
        if(!msgo) msgo = result.Messages[0];
        if(msgo) msg = msgo.MessageText;
    }
    if(result.ErrorCode && result.Message) msg = result.Message;
    showErrorMessage(msg);
}

function showErrorMessage(text) {
    toastUtil.Error(text);
    console.error(text);
}

function showCartItemAdded(result, quantity) {
    $('.cartModal .isa-modal__product-name').text(result.Name || result.ProductName);
    let $productMeta = $('.cartModal .isa-modal__product-meta');
    let $productImage = $('.isa-modal__product-image');
    $productMeta.empty();
    let $modalBlock = $('.cross-sell-modal');
    $modalBlock.empty();
    if(result.ProductImage) $productImage.attr('src', result.ProductImage);
    if(result.ProductFacetList && result.ProductFacetList.length) {
        result.ProductFacetList.forEach(function (facet) {
            if(facet.Value) {
                $productMeta.append(`<div class="isa-modal__product-meta-item" ><div><span>${facet.Name}:</span></div><div><span style="font-weight: bold; word-wrap: break-word">${facet.Value}</span></div></div>`);
            }
        });
    } else if(result.Facets && result.Facets.length) {
        result.Facets.forEach(function (facet) {
            if(facet.Value) {
                $productMeta.append(`<div class="isa-modal__product-meta-item" ><div><span>${facet.Name}:</span></div><div><span style="font-weight: bold; word-wrap: break-word">${facet.Value}</span></div></div>`);
            }
        });
    }
    let $qtyText = $('#hdnQuantityText').val();
    $productMeta.append(`<div class="isa-modal__product-meta-item" ><div><span>${$qtyText}:</span></div><div><span style="font-weight: bold; word-wrap: break-word">${quantity}</span></div></div>`);
    if(marketSettings.CurrencySymbolAbbreviation) {
        if(result.Subtotal % 1 === 0) {
            $('.isa-modal__cart-total').text(currencyFormatter.format(result.Subtotal).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
        } else {
            $('.isa-modal__cart-total').text(fractionCurrencyFormatter.format(result.Subtotal).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
        }
    } else {
        if(result.Subtotal % 1 === 0) $('.isa-modal__cart-total').text(currencyFormatter.format(result.Subtotal));
        else $('.isa-modal__cart-total').text(fractionCurrencyFormatter.format(result.Subtotal));
    }
    crossSellService.updateSubHeader(result);
    crossSellService.updateCrossSellCards(result);
    $('#hidden-cartItem-count').val(result.QuantityTotal);
    $('.header__cart-items').text(result.QuantityTotal).removeClass('d-none');
    $('.cartModal').modal('show');
}

function addGtmTagToAddToCart(sku, isCreateALink = false) {
    if(!googleAnalytics) return;
    var memberId = googleAnalytics.MemberId;
    var memberType = googleAnalytics.MemberType;
    var currency = googleAnalytics.Currency;
    var cultureCode = googleAnalytics.CultureCode;
    var catalog = googleAnalytics.CatalogName;
    var category = googleAnalytics.Products[0].ProductFamilyName;
    var marketingCloudUserId = googleAnalytics.MarketingCloudUserId;
    var isagenixMemberSubType = googleAnalytics.IsagenixMemberSubType;
    var preferredCultureCode = googleAnalytics.PreferredCultureCode;
    var hasAutoship = googleAnalytics.HasAutoship;
    var canEnroll = googleAnalytics.CanEnroll;
    var hasIsaDelivery = googleAnalytics.HasIsaDelivery;
    var daysSinceEnrollment = googleAnalytics.DaysSinceEnrollment;
    setDataForAllProducts(catalog, category, currency, memberType, memberId, cultureCode, marketingCloudUserId, isagenixMemberSubType, preferredCultureCode, hasAutoship, canEnroll, hasIsaDelivery, daysSinceEnrollment);
    var products = {
        'name': googleAnalytics.Products[0].ProductName,
        'id': sku,
        'price': googleAnalytics.Products[0].Price,
        'brand': googleAnalytics.Products[0].Brand,
        'category': googleAnalytics.Products[0].ProductFamilyName,
        'quantity': googleAnalytics.Products[0].Quantity
    };
    if(window.lastQueryID && window.lastQueryID !== null && window.lastQueryID.trim() !== '') {
        products.queryId = window.lastQueryID.trim();
    }
    if(products.queryId && products.queryId !== null && products.queryId.trim() !== '') {
        const indexName = window.algoliaData.searchIndexName;
        if(indexName !== undefined && indexName !== null) {
            products.indexName = indexName;
        }
    }
    if(isCreateALink) {
        addGtmTagToCart(products, googleAnalytics.EventName);
    } else if(isAlgoliaSearchEnabled) {
        addGtmTagToCart(products, 'SRPAddToCart');
    } else {
        addGtmTagToCart(products);
    }
    googleAnalytics = null;
}

function checkIsaDeliveryProduct(productList) {
    for (let i = 0; i < productList.length; i++) {
        let userHasIsaDelivery = $('#userHasIsaDelivery').val();
        if(productList[i].IsIsaDelivery) {
            if(userHasIsaDelivery === 'true' || productList[i].CartHasIsaDelivery) {
                let $productElement = $(`[data-id="${productList[i].Id}"`);
                let $addToCartButtonElement = $productElement.find('.addToCart,.addKitToCart,.addPackToCart');
                if($addToCartButtonElement.length > 0) {
                    $addToCartButtonElement.text(plpData.Labels.AlreadyPurchasedLabel);
                    $addToCartButtonElement.attr('disabled', 'disabled');
                }
            }
        }
    }
}

async function checkStock(productList) {
    if(!productList || productList.length < 1) return;
    checkIsaDeliveryProduct(productList);
    let tempUnavailableProductIds = productList.filter(i => i.IsTemporaryUnavailable).map(i => i.Id);
    updateProductsAsUnavailable(tempUnavailableProductIds, plpData.Labels.UnavailableLabel);
    let comingSoonProductIds = productList.filter(i => i.IsComingSoon).map(i => i.Id);
    updateProductsAsUnavailable(comingSoonProductIds, plpData.Labels.ComingSoonMsg);
}

function updateProductsAsUnavailable(productIds, buttonText) {
    if(productIds !== undefined && productIds.length !== 0) {
        productIds.forEach(function (currentValue) {
            let $productElement = $(`[data-id="${currentValue}"`);
            let $addToCartButtonElement = $productElement.find('.addToCart,.addKitToCart,.addPackToCart');
            if($addToCartButtonElement.length > 0) {
                $addToCartButtonElement.text(buttonText);
                $addToCartButtonElement.attr('disabled', 'disabled');
            }
        });
    }
}

function toggleTabs(skipUpdate) {
    resourceTabSelected = !resourceTabSelected;
    setActiveTab();
    if(!skipUpdate) updateFilter();
}

function checkResourceTabIsSelected() {
    const params = new URLSearchParams(window.location.search);
    const queryParam = 't';
    if(params.has(queryParam)) {
        let searchType = params.get(queryParam);
        if(searchType.toLowerCase() === 'resources') return true;
    }
    return false;
}

function navigateHistory(querystring) {
    if(resourceTabSelected) return;
    setPage(querystring);
    var filters = querystring ? querystring.substring(1) : '';
    if($plpSearch.length) updateSearchResults(false, filters);
    else updateFilterResults(false, filters);
}

function setPage(querystring) {
    var qs = new URLSearchParams(querystring);
    page = parseInt(qs.get(PAGE));
    if(isNaN(page)) page = 1;
}

export function getToastMessage(result) {
    if(result && result.Messages) {
        let toastMsg = result.Messages.find(x => x.IsToast === true);
        if(toastMsg) return toastMsg.MessageText;
        return '';
    }
    return '';
}

function pushItemToExistingShareLinkArray(sku, result) {
    var shareLinkItem = { ProductSku: sku, ShareCode: result.ShareLinkCode, ShareLinkId: result.ShareLinkId, ShareLinkUrl: result.ShareLinkUrl, ShareType: 2 };
    plpsharelinklist.push(shareLinkItem);
}

function createALink(event) {
    event.preventDefault();
    event.stopPropagation();
    createALinkCore($(this));
}

async function createALinkCore($this) {
    if($this === null || $this === undefined) {
        $this = $(this);
    }
    let sku = $this.data('sku').toString();
    let id = $this.data('product-id').toString();
    hideErrorMessage();
    let shouldShowMaximumModal = false;
    let result = null;
    try {
        showSpinner(CREATE_COPY_LINK_STARTED_MESSAGE);
        result = await rcService.saveShareLink({ productSku: sku });
        if(result && result.IsSuccessful) {
            labelChange(id);
            pushItemToExistingShareLinkArray(sku, result);
            await navigator.clipboard.writeText(result.ShareLinkUrl);
        } else {
            if(result.MaximumShareLinkCartsCount && result.MaximumShareLinkCartsCount > 0 && result.Messages.find(m => m.CommerceCode === 'CanCreateShareLinkCartsFailed')) {
                shouldShowMaximumModal = true;
                $('#BPMaximumLinksAllowedMessage').text($('#BPMaxLinksMessageWithoutCount').text().replace('{#}', result.MaximumShareLinkCartsCount.toString()));
            } else {
                const message = result.Messages.find(m => m.CommerceCode === 'ShareLinkProductCreateFailed' && m.MessageText !== null);
                if(message) {
                    console.log('Create A Link Failed:', message.MessageText);
                    showErrorMessage(message.MessageText);
                }
            }
        }
        const response = await getGoogleAnalyticsDetails({ sku });
        if(response && response.EventName) {
            googleAnalytics = response;
            addGtmTagToAddToCart(sku, true);
        }
        if(result && result.IsSuccessful) {
            hideSpinner(CREATE_COPY_LINK_COMPLETED_MESSAGE);
        } else {
            hideSpinner(CREATE_COPY_LINK_ERROR_MESSAGE);
        }
        if(shouldShowMaximumModal) {
            $('#maximumRecommendedModal').removeClass('d-none').show();
        }
    } catch (ex) {
        hideSpinner(CREATE_COPY_LINK_ERROR_MESSAGE);
        console.error(ex);
        if(result && result.Messages) {
            const message = result.Messages.find(m => m.CommerceCode === 'ShareLinkProductCreateFailed' && m.MessageText !== null);
            if(message) {
                showErrorMessage(message.MessageText);
            } else {
                showErrorMessage($('#cart-unexpected-error-item').val() || 'Unexpected error');
            }
        }
    }
}

async function copyShareLink(event) {
    event.preventDefault();
    event.stopPropagation();
    let sku = $(this).data('sku').toString();
    let shareLinkFound = plpsharelinklist.find(f => f.ProductSku === sku);
    if(shareLinkFound !== undefined && shareLinkFound !== null && shareLinkFound.ShareLinkUrl) {
        let id = $(this).data('product-id').toString();
        if(id) {
            labelChange(id);
            await navigator.clipboard.writeText(shareLinkFound.ShareLinkUrl);
        } else {
            console.log('Copy Link Failed:', bpLabels.CopyLinkFailed);
            showErrorMessage(bpLabels.CopyLinkFailed);
        }
    } else {
        console.log('Copy Link Failed:', bpLabels.CopyLinkFailed);
        showErrorMessage(bpLabels.CopyLinkFailed);
    }
}

function labelChange(pid) {
    const selector = `.plp__list-item [data-product-id="${pid}"]`;
    $(selector).removeClass('quickCreateALink');
    $(selector).addClass('linkCopied');
    if(isAlgoliaSearchEnabled && window.algoliaData) {
        $(selector).text($('#hidden-linkCopiedText').val());
    } else {
        $(selector).text(bpLabels.LinkCopied);
    }

    let timeoutId = setTimeout(function () {
        clearTimeout(timeoutId);
        const innerSelector = `.plp__list-item [data-product-id="${pid}"]`;
        $(selector).removeClass('linkCopied');
        $(selector).addClass('quickCopyLink');
        if(isAlgoliaSearchEnabled && window.algoliaData) {
            $(innerSelector).text(window.algoliaData.copyLinkLabelText);
        } else {
            $(innerSelector).text(bpLabels.CopyLink);
        }
    }, 4000);
}

function hideErrorMessage($element) {
    if($element) {
        $element.parents('.error__msg').removeClass(IS_ACTIVE).addClass(IS_HIDDEN);
        $($element).children('.error__text').text('');
    } else {
        $('.error__text').text('').parents('.error__msg').removeClass(IS_ACTIVE).addClass(IS_HIDDEN);
    }
}

async function addToCartButtonClickHandler(event) {
    event.preventDefault();
    event.stopPropagation();
    let sku = $(this).data('sku');
    let pageId = $plpSearch.data('page-id');
    const detailsRequest = { sku: sku, pageId: pageId };
    if($('.plp--search.container.is-individual-link.plp--search-aa').length) {
        if($(this).hasClass('inventoryManagement')) {
            const result = await cartService.getProductDetails(detailsRequest);
            if(result !== null && typeof result === 'object' && result.Id && result.Id !== null && result.IsCheckStockAndZeroQuantity) {
                window.location.href = $(this).attr('data-url');
            } else {
                createALinkCore($(this));
            }
        } else {
            createALinkCore($(this));
        }
    } else {
        if(sku) {
            const detailsElement = $(this).closest('.plp__product-details');
            const inputNumberElement = $(detailsElement).find('.price__quantity-sign.price__quantity-sign--amount');
            const qantityValue = $(inputNumberElement).val();
            showSpinner(ADD_TO_CART_LOADING_STARTED_MESSAGE);
            try {
                const result = await cartService.getProductDetails(detailsRequest);
                if(result !== null && typeof result === 'object' && result.Id && result.Id !== null) {
                    let request = {
                        FamilyId: result.FamilyId,
                        ProductId: `Isagenix_Master|${result.Id}|`,
                        Sku: result.Sku,
                        Quantity: qantityValue,
                        ProductPageRelativeUrl: result.Url,
                        PriceType: result.DefaultPriceType,
                        TryOnce: false,
                        IsQuickAdd: true
                    };
                    if(!result.IsKit) {
                        request.FamilyName = result.Name;
                    }
                    request = addGlobalQueryIdToRequest(request, window.lastQueryID);
                    let response;
                    initCurrencyFormatter();
                    if(result.IsKit) {
                        response = await cartService.addKitToCart(request);
                    } else {
                        response = await cartService.addToCart(request);
                    }

                    if(response && response.IsSuccessful) {
                        googleAnalytics = response.GoogleAnalyticsProperties;
                        cartService.updateQSForMergeCart();
                        hideCartModalShoppingContext(result.DefaultPriceType);
                        showCartItemAdded(response, qantityValue);
                        addGtmTagToAddToCart(sku);
                        hideSpinner(ADD_TO_CART_LOADING_COMPLETED_MESSAGE);
                    } else {
                        console.error(response);
                        addToCartFailed(response);
                        hideSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
                    }
                } else {
                    hideSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
                    console.error('Product details not found for SKU:', sku);
                    if($('#cart-unexpected-error-item').length) {
                        toastUtil.Error($('#cart-unexpected-error-item').val());
                    }
                }
            } catch (ex) {
                console.error(ex);
                hideSpinner(ADD_TO_CART_LOADING_ERROR_MESSAGE);
                if($('#cart-unexpected-error-item').length) {
                    toastUtil.Error($('#cart-unexpected-error-item').val());
                }
            }
        }
    }
}

async function loadResourcesAfterSearchResults() {
    try {
        let searchData = {
            searchTerm: $('.form-input--search').attr('data-value'),
            pageId: $plpSearch.data('page-id'),
            configId: $plpSearch.data('config-id'),
            page: resourcePage,
            pageSize: plpResourceData.PagingSize,
            sort: $plpSort.val(),
            isagenixContext: $plpSearch.data('isagenixcontext')
        };
        let result = await searchService.searchResources(searchData);
        plpResourceData = result;

        if(isSearchPageRendering && $(newResourcesTabSelector).length) {
            $(newResourcesTabSelector).text(result.TotalNumOfResults);
        }
    } catch (ex) {
        console.error(ex);
    }
}

function renderResourcesTab() {
    try {
        if(!plpResourceData) return;
        plpResourceData.NumOfResultsReturned = plpResourceData.Resources.length;
        let resourceListHtml = resourcesListTemplate(plpResourceData.Resources);
        $plpResources.html(resourceListHtml);
        updateCount(plpResourceData.NumOfResultsReturned, plpResourceData.TotalNumOfResults);
    } catch (ex) {
        console.error(ex);
    }
}

function showMaximumModalOnLoad() {
    const $maxModal = $('#maximumRecommendedModal');
    if($maxModal.length && $maxModal.data('show-on-load')) {
        $maxModal.removeClass('d-none').show();
    }
}

$(function () {
    $plpSearch = $('.plp--search');
    $plpFilter = $('.plp');
    window.spinnerActive = false;
    isAlgoliaSearchEnabled = $('#hidden-isAlgoliaSearchEnabled').val() === 'true' && $('#hidden-isAlgoliaSeachPageRendering').val() === 'true';
    $(document).on('click', '.ais-InfiniteHits .plp__product-card-content .ais-search-cta-button:not(.isPack):not(.inventoryManagement):not(.quickCopyLink)', addToCartButtonClickHandler);
    const selectorIndividualLinkFlow = '.plp--search.is-individual-link.plp--search-aa .ais-InfiniteHits .plp__product-card-content .ais-search-cta-button';
    $(document).on('click', `${selectorIndividualLinkFlow}.isPack, ${selectorIndividualLinkFlow}.inventoryManagement`, addToCartButtonClickHandler);
    const skipLoadingSearchScript = $('#hidden-skip-loading-search-scipt').val() === 'true';
    newProductsTabSelector = $('#plp__tabs-search-products-count');
    newResourcesTabSelector = $('#plp__tabs-search-resources-count');
    isSearchPageRendering = $('#hidden-isAlgoliaSeachPageRendering').val() === 'true';
    if($plpSearch.length && skipLoadingSearchScript) return;
    if($plpSearch.length) {
        resourceTabSelected = checkResourceTabIsSelected();
        setActiveTab();
        if($(legacyElement).length === 0) {
            initEventHandlers();
            loadInitialResults().finally(showMaximumModalOnLoad);
        }
    } else {
        initEventHandlers();
        loadInitialResults().finally(showMaximumModalOnLoad);
    }
    if(!isAlgoliaSearchEnabled) {
        $('.plp--search .plp__content .plp__tab.tab-content').on('click', '.increase-items', function () { increaseItemsSearch($(this)); });
        $('.plp--search .plp__content .plp__tab.tab-content').on('click', '.decrease-items', function () { decreaseItemsSearch($(this)); });
    }

    if(isSearchPageRendering) {
        loadResourcesAfterSearchResults();
    }
    if(!(isAlgoliaSearchEnabled && isSearchPageRendering)) {
        window.lastSearch = window.location.search;
    }

    $(document).on('click', '.plpFilter__toggle-collapse', function () {
        let $btn = $(this);
        let isCollapsed = $btn.hasClass('collapsed');
        let $expand = $btn.children('.sr-only').eq(0);
        let $collapse = $btn.children('.sr-only').eq(1);
        let panelId = $btn.attr('href') || $btn.attr('aria-controls');
        if(panelId && panelId.startsWith('#')) panelId = panelId.substring(1);
        let $panel = $('#' + panelId);
        if(isCollapsed) {
            $expand.attr('aria-hidden', 'false');
            $collapse.attr('aria-hidden', 'true');
            $panel.attr('aria-hidden', 'true').attr('tabindex', '-1').attr('hidden', 'hidden');
        } else {
            $expand.attr('aria-hidden', 'true');
            $collapse.attr('aria-hidden', 'false');
            $panel.attr('aria-hidden', 'false').removeAttr('tabindex').removeAttr('hidden');
        }
    });

    $(document).on('click', '.plp__product-promotion', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });
});
